import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';

const useLoginTrack = () => {
  const trackVerifyEmail = (username: string) => {
    AnalyticsManager.instance().setUserId(username);
  };

  const hitLoginPage = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.hit_login_page);
  };

  const clickSignUp = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_sign_up, {
      from: 'primary_access',
    });
  };

  const clickLogout = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_logout, {
      from: 'pop_up',
    });
  };

  const setUserId = (username: string) => {
    AnalyticsManager.instance().setUserId(username);
  };

  return {
    trackVerifyEmail,
    hitLoginPage,
    clickSignUp,
    clickLogout,
    setUserId,
  };
};

export default useLoginTrack;
